(function () {
  'use strict';

  var ULTRA_PATH = '/products/ultra-sharp-2-0-classic-gold';
  var PRODUCT_ID = 1563927871590;

  if (window.location.pathname !== ULTRA_PATH) return;

  var form = document.querySelector('[data-product-form]');
  if (!form || form.getAttribute('data-bs-ultra-live-variants') === 'ready') return;

  var variantInput = form.querySelector('[data-variant-id]');
  var sizeSelector = form.querySelector('.size-selector');
  var sizeOptions = sizeSelector && sizeSelector.querySelector('.size-options');
  var selectedSize = sizeSelector && sizeSelector.querySelector('[data-selected-size]');
  var finishSelector = form.querySelector('.finish-selector');
  var finishOptions = finishSelector && finishSelector.querySelector('.finish-options');
  var selectedFinish = finishSelector && finishSelector.querySelector('[data-selected-finish]');
  var submitButton = form.querySelector('button[type="submit"]');
  var formStatus = form.querySelector('[data-form-status]');
  var mainImage = document.querySelector('[data-main-image]');
  var imageCaption = document.querySelector('[data-image-caption]');
  var imageBadge = document.querySelector('.hero .image-badge');
  var stickyVariant = document.querySelector('[data-sticky-variant]');
  var priceElement = document.querySelector('.hero .offer-line .price');
  var thumbnails = Array.prototype.slice.call(document.querySelectorAll('.hero .thumb'));
  var variants = [];
  var colorIndex = 0;
  var sizeIndex = 1;
  var currentVariant = null;
  var productCurrency = 'USD';

  if (!variantInput || !sizeOptions || !finishOptions) return;

  function variantImage(variant) {
    if (!variant || !variant.featured_image) return '';
    return variant.featured_image.src || variant.featured_image.url || '';
  }

  function optionValue(variant, index) {
    return variant && Array.isArray(variant.options) ? variant.options[index] : '';
  }

  function uniqueValues(index) {
    var values = [];
    variants.forEach(function (variant) {
      var value = optionValue(variant, index);
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function findVariant(size, color) {
    return variants.find(function (variant) {
      return optionValue(variant, sizeIndex) === size && optionValue(variant, colorIndex) === color;
    }) || null;
  }

  function formatSize(size) {
    return size === '20oz' ? '20oz / 600ml' : size;
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: productCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function swatchClass(color) {
    var value = String(color || '').toLowerCase();
    if (value.indexOf('multicolor') !== -1) return 'swatch-multicolor';
    if (value.indexOf('rose') !== -1) return 'swatch-rose';
    if (value.indexOf('copper') !== -1) return 'swatch-copper';
    if (value.indexOf('black') !== -1) return 'swatch-black';
    return '';
  }

  function updateGallery(variant) {
    var color = optionValue(variant, colorIndex);
    var size = optionValue(variant, sizeIndex);
    var src = variantImage(variant);
    if (mainImage && src) {
      mainImage.src = src;
      mainImage.alt = 'Ultra Sharp 2.0 latte art pitcher in ' + color + ', ' + size;
    }
    if (imageCaption) imageCaption.textContent = color + ' · ' + size;
    if (imageBadge) imageBadge.textContent = size.toUpperCase() + ' · COMMERCIAL BUILD';

    thumbnails.forEach(function (thumb) {
      var label = [thumb.dataset.alt, thumb.dataset.caption, thumb.getAttribute('aria-label')].join(' ').toLowerCase();
      var matches = label.indexOf(color.toLowerCase()) !== -1 || (src && thumb.dataset.src === src);
      thumb.classList.toggle('is-active', matches);
    });
  }

  function updateColorThumbnailAvailability() {
    thumbnails.forEach(function (thumb) {
      var label = [thumb.dataset.alt, thumb.dataset.caption, thumb.getAttribute('aria-label')].join(' ').toLowerCase();
      var color = uniqueValues(colorIndex).find(function (value) {
        return label.indexOf(value.toLowerCase()) !== -1;
      });
      if (!color) return;
      var available = variants.some(function (variant) {
        return optionValue(variant, colorIndex) === color && variant.available;
      });
      thumb.classList.toggle('is-unavailable', !available);
      thumb.disabled = !available;
      thumb.setAttribute('aria-disabled', String(!available));
      var badge = thumb.querySelector(':scope > span');
      if (badge && available) badge.remove();
      var aria = thumb.getAttribute('aria-label') || '';
      thumb.setAttribute('aria-label', available ? aria.replace(/sold-out\s*/i, '') : aria);
    });
  }

  function setCurrentVariant(variant) {
    currentVariant = variant;
    var available = Boolean(variant && variant.available);
    if (variantInput) variantInput.value = variant ? String(variant.id) : '';
    if (submitButton) {
      submitButton.disabled = !available;
      submitButton.setAttribute('aria-disabled', String(!available));
    }
    if (!variant) return;

    var color = optionValue(variant, colorIndex);
    var size = optionValue(variant, sizeIndex);
    if (selectedFinish) selectedFinish.textContent = color;
    if (selectedSize) selectedSize.textContent = formatSize(size);
    if (stickyVariant) stickyVariant.textContent = color.replace('Mirror ', '') + ' · ' + size;
    if (priceElement) priceElement.textContent = formatMoney(variant.price);
    updateGallery(variant);
  }

  function renderFinishes(size, preferredColor) {
    finishOptions.innerHTML = '';
    var sizeVariants = variants.filter(function (variant) {
      return optionValue(variant, sizeIndex) === size;
    });
    var selected = sizeVariants.find(function (variant) {
      return optionValue(variant, colorIndex) === preferredColor && variant.available;
    }) || sizeVariants.find(function (variant) { return variant.available; }) || sizeVariants[0] || null;
    finishOptions.style.gridTemplateColumns = 'repeat(' + Math.min(sizeVariants.length, 4) + ', minmax(0, 1fr))';

    sizeVariants.forEach(function (variant) {
      var color = optionValue(variant, colorIndex);
      var label = document.createElement('label');
      label.className = 'finish-option' + (variant === selected ? ' is-selected' : '') + (!variant.available ? ' is-disabled' : '');
      if (!variant.available) label.setAttribute('aria-disabled', 'true');

      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'bs-ultra-finish';
      radio.value = String(variant.id);
      radio.dataset.finish = color;
      radio.dataset.image = variantImage(variant);
      radio.checked = variant === selected;
      radio.disabled = !variant.available;

      var swatch = document.createElement('span');
      swatch.className = 'finish-swatch ' + swatchClass(color);
      swatch.setAttribute('aria-hidden', 'true');
      if (String(color).toLowerCase().indexOf('black') !== -1) {
        swatch.style.background = '#171717';
      }

      var text = document.createElement('span');
      text.textContent = color.replace('Mirror ', '') + (variant.available ? '' : ' — Sold out');

      label.appendChild(radio);
      label.appendChild(swatch);
      label.appendChild(text);
      finishOptions.appendChild(label);

      radio.addEventListener('change', function () {
        if (!radio.checked || !variant.available) return;
        finishOptions.querySelectorAll('.finish-option').forEach(function (item) {
          item.classList.toggle('is-selected', item === label);
        });
        setCurrentVariant(variant);
      });
    });

    setCurrentVariant(selected && selected.available ? selected : null);
  }

  function renderSizes(preferredSize, preferredColor) {
    sizeOptions.innerHTML = '';
    var sizes = uniqueValues(sizeIndex);
    var activeSize = sizes.indexOf(preferredSize) !== -1 ? preferredSize : sizes[0];

    sizes.forEach(function (size) {
      var available = variants.some(function (variant) {
        return optionValue(variant, sizeIndex) === size && variant.available;
      });
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'size-option' + (size === activeSize ? ' is-selected' : '') + (!available ? ' is-disabled' : '');
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.dataset.size = size;
      button.appendChild(document.createTextNode(size + ' '));
      var small = document.createElement('small');
      small.textContent = available ? 'Available' : 'Sold out';
      button.appendChild(small);
      sizeOptions.appendChild(button);

      button.addEventListener('click', function () {
        if (!available) return;
        sizeOptions.querySelectorAll('.size-option').forEach(function (item) {
          item.classList.toggle('is-selected', item === button);
        });
        var currentColor = currentVariant ? optionValue(currentVariant, colorIndex) : preferredColor;
        renderFinishes(size, currentColor);
      });
    });

    renderFinishes(activeSize, preferredColor);
  }

  function openCartDrawer() {
    ['cart:refresh', 'cart:open', 'theme:cart:open', 'baristaswag:cart-open'].forEach(function (eventName) {
      window.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
    });
    if (window.BaristaSwagCartDrawer && typeof window.BaristaSwagCartDrawer.open === 'function') {
      window.BaristaSwagCartDrawer.open();
      return true;
    }
    var trigger = [
      '[data-cart-drawer-trigger]',
      '[data-action="open-mini-cart"]',
      '.js-drawer-open-cart',
      'button[aria-controls="CartDrawer"]',
      'button[aria-controls="cart-drawer"]'
    ].map(function (selector) { return document.querySelector(selector); }).find(Boolean);
    if (trigger) trigger.click();
    return Boolean(trigger);
  }

  function updateAvailabilityCopy() {
    var available = variants.filter(function (variant) { return variant.available; });
    var sizes = uniqueValues(sizeIndex).filter(function (size) {
      return available.some(function (variant) { return optionValue(variant, sizeIndex) === size; });
    });
    var allColors = uniqueValues(colorIndex).filter(function (color) {
      return available.some(function (variant) { return optionValue(variant, colorIndex) === color; });
    });
    var colorsForSize = function (size) {
      return uniqueValues(colorIndex).filter(function (color) {
        var variant = findVariant(size, color);
        return variant && variant.available;
      });
    };
    var specRows = Array.prototype.slice.call(document.querySelectorAll('.spec-list > div'));
    specRows.forEach(function (row) {
      var term = row.querySelector('dt');
      var value = row.querySelector('dd');
      if (!term || !value) return;
      if (term.textContent.trim() === 'Current available size') {
        term.textContent = 'Available sizes';
        value.textContent = sizes.join(' and ');
      } else if (term.textContent.trim() === '12oz model') {
        value.textContent = colorsForSize('12oz').join(', ');
      } else if (term.textContent.trim() === 'Available finishes') {
        value.textContent = allColors.join(', ');
      }
    });
    var stockNote = document.querySelector('.size-story small');
    if (stockNote) stockNote.textContent = 'Current stock on this page: ' + sizes.join(' and ') + ' in selected finishes.';
    var sizeFaq = Array.prototype.slice.call(document.querySelectorAll('.faq-list details')).find(function (details) {
      return /Which sizes are available right now/i.test(details.querySelector('summary')?.textContent || '');
    });
    var sizeFaqAnswer = sizeFaq && sizeFaq.querySelector('p');
    if (sizeFaqAnswer) {
      sizeFaqAnswer.textContent = sizes.map(function (size) {
        return size + ': ' + colorsForSize(size).join(', ');
      }).join('. ') + '.';
    }
    var finalSub = document.querySelector('.final-sub');
    if (finalSub) finalSub.textContent = 'Ultra Sharp 2.0 · current sizes and finishes · lifetime handle guarantee';
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    if (!currentVariant || !currentVariant.available) {
      if (formStatus) formStatus.textContent = 'Please choose an available size and finish.';
      return;
    }

    var variantId = Number(currentVariant.id);
    var color = optionValue(currentVariant, colorIndex);
    var size = optionValue(currentVariant, sizeIndex);
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('is-loading');
      submitButton.setAttribute('aria-busy', 'true');
    }
    if (formStatus) formStatus.textContent = 'Adding to cart…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (error) {
          throw new Error(error.description || error.message || 'Unable to add this pitcher');
        });
      }
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to verify the cart');
      return response.json();
    }).then(function (cart) {
      var line = cart.items.find(function (item) { return Number(item.variant_id) === variantId; });
      if (!line) throw new Error('The selected pitcher was not added. Please try again.');
      openCartDrawer();
      if (formStatus) formStatus.textContent = 'Added to cart.';
      window.dispatchEvent(new CustomEvent('baristaswag:product-added', {
        detail: {
          productId: PRODUCT_ID,
          variantId: variantId,
          finish: color,
          size: size,
          value: Number(currentVariant.price || 0) / 100,
          currency: productCurrency
        }
      }));
    }).catch(function (error) {
      if (formStatus) formStatus.textContent = error.message || 'The pitcher could not be added. Please try again.';
      console.error('[Barista Swag Ultra variants]', error);
    }).finally(function () {
      if (submitButton) {
        submitButton.disabled = !currentVariant || !currentVariant.available;
        submitButton.classList.remove('is-loading');
        submitButton.removeAttribute('aria-busy');
      }
    });
  }, true);

  fetch(ULTRA_PATH + '.js', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  }).then(function (response) {
    if (!response.ok) throw new Error('Unable to load live variants');
    return response.json();
  }).then(function (product) {
    if (Number(product.id) !== PRODUCT_ID || !Array.isArray(product.variants)) {
      throw new Error('Unexpected product data');
    }

    variants = product.variants;
    productCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var optionNames = (product.options || []).map(function (option) {
      return String(option && option.name ? option.name : option).toLowerCase();
    });
    colorIndex = optionNames.indexOf('color');
    sizeIndex = optionNames.indexOf('size');
    if (colorIndex === -1) colorIndex = 0;
    if (sizeIndex === -1) sizeIndex = colorIndex === 0 ? 1 : 0;

    var initial = variants.find(function (variant) {
      return String(variant.id) === String(variantInput.value) && variant.available;
    }) || variants.find(function (variant) { return variant.available; });
    if (!initial) throw new Error('No live Ultra Sharp variant is available');

    renderSizes(optionValue(initial, sizeIndex), optionValue(initial, colorIndex));
    updateColorThumbnailAvailability();
    updateAvailabilityCopy();
    form.setAttribute('data-bs-ultra-live-variants', 'ready');
  }).catch(function (error) {
    form.setAttribute('data-bs-ultra-live-variants', 'error');
    if (formStatus) formStatus.textContent = 'Live availability could not load. Please refresh and try again.';
    console.error('[Barista Swag Ultra variants]', error);
  });
})();
